import React from "react";
import { InputNumber, Tooltip, InputNumberProps } from "antd";

interface PercentageNumberInputProps extends Omit<InputNumberProps, "onChange" | "value" | "formatter" | "parser"> {
  value?: number;
  onChange?: (val: string | number | null) => void;
  mode: "number" | "percentage";
  estimatedDollarAmount?: number;
  moneyFormatter?: (val: string | number | undefined) => string;
  moneyParser?: (val: string | undefined) => number;
}

export const PercentageNumberInput: React.FC<PercentageNumberInputProps> = ({
  value,
  onChange,
  mode,
  estimatedDollarAmount,
  moneyFormatter,
  moneyParser,
  ...props
}) => {
  if (mode === "percentage") {
    const tooltipTitle = estimatedDollarAmount ? `Estimated: $${estimatedDollarAmount.toFixed(2)}` : undefined;

    return (
      <Tooltip title={tooltipTitle}>
        <InputNumber
          {...props}
          size="small"
          suffix="%"
          value={value}
          onChange={onChange}
          formatter={(val) => {
            if (!val) return "";
            return `${val}%`;
          }}
          parser={(val) => {
            if (!val) return 0;
            return parseFloat(val.replace("%", ""));
          }}
          className="!w-[140px]"
          style={{ fontVariantNumeric: "tabular-nums", ...props.style }}
          min={0}
        />
      </Tooltip>
    );
  }

  // Number mode
  return (
    <InputNumber
      {...props}
      size="small"
      prefix="$"
      formatter={(val) => {
        if (typeof val === "number") {
          return moneyFormatter ? moneyFormatter(val) : `$${val.toFixed(2)}`;
        }
        return val ? `${val}` : "";
      }}
      parser={(val) => {
        if (typeof val === "string") {
          return moneyParser ? moneyParser(val) : parseFloat(val.replace(/\$\s?|(,*)/g, ""));
        }
        return 0;
      }}
      value={value}
      onChange={onChange}
      className="!w-[140px]"
      style={{ fontVariantNumeric: "tabular-nums", ...props.style }}
      min={0}
    />
  );
};
